/**
 * engagementcommentreducer.js
 * Created by yonamine on 05/11/2020.
 */
import {
	ADD_TO_ENGAGEMENT_COMMENT_SLICE,
	CLEAR_ENGAGEMENT_COMMENTS,
	CREATE_ENGAGEMENT_COMMENT,
	CREATE_ENGAGEMENT_COMMENT_REPLY,
	DELETE_ENGAGEMENT_COMMENT_CHILD,
	DELETE_ENGAGEMENT_COMMENT_PARENT,
	DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL,
	GET_ALL_ENGAGEMENT_COMMENTS,
	REMOVE_ENGAGEMENT_COMMENTS_FILTER,
	SET_ENGAGEMENT_COMMENTS_CONFIG_DATA,
	SET_ENGAGEMENT_COMMENTS_FILTER,
	SET_SELECTED_ENGAGEMENT_COMMENT_GUID,
	TOGGLE_INLINE_COMMENTS_EDITOR,
	UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
	UPDATE_ENGAGEMENT_COMMENT,
	UPDATE_ENGAGEMENT_COMMENT_STATUS
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {EngagementCommentStatusIds, EngagementCommentStatus} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import _ from 'lodash';
import {getState, setState} from '@ey/canvascoreservices/GenericState';
import {COMMENTS_COUNT} from '../../store/commonStore/stateKeys/global';

const mergeCommentGenericStateFromReduxState = (commentsStateKey, state, entityUid = null) => {
	if (entityUid && state?.[entityUid]) {
		const commentsCountKey = `${COMMENTS_COUNT}_${entityUid}`;
		const commentsCount = Array.isArray(state?.[entityUid])
			? state[entityUid].filter((c) => {
					return c.engagementCommentStatusId !== EngagementCommentStatus.closed;
				}).length
			: 0;
		if (getState(commentsCountKey)?.commentsCount !== commentsCount) {
			setState(commentsCountKey, {commentsCount});
		}
	}
	if (commentsStateKey) {
		const commentStateConfig = getState(commentsStateKey, state).config;
		setState(commentsStateKey, {...state, config: commentStateConfig});
	}
};
const getStateForComments = (state, commentsStateKey) => {
	const commentsState = commentsStateKey ? getState(commentsStateKey, state) : state;
	if ((!commentsState?.config || !Object.keys(commentsState.config).length) && state.config && Object.keys(state.config).length) {
		commentsState.config = state.config;
		setState(commentsStateKey, commentsState);
	}
	return commentsState;
};
export default function engagementCommentReducer(state = initialstate.engagementComments, action) {
	switch (action.type) {
		case SET_ENGAGEMENT_COMMENTS_CONFIG_DATA:
			if (action) {
				return {
					...state,
					config: action.config
				};
			}
			break;
		case CLEAR_ENGAGEMENT_COMMENTS:
			if (action) {
				return clearEngagementComments(action.entityUid, state, action.args);
			}
			break;
		case SET_SELECTED_ENGAGEMENT_COMMENT_GUID:
			if (action) {
				return setSelectedEngagementCommentGuid(state, action.guid, action.args);
			}
			break;
		case GET_ALL_ENGAGEMENT_COMMENTS:
			if (action.response) {
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				return applyResponse(commentsState, action);
			}
			return state;
		case SET_ENGAGEMENT_COMMENTS_FILTER:
			if (action) {
				return addFilterToEngagementComments(state, action.filter, action.args);
			}
			return state;
		case REMOVE_ENGAGEMENT_COMMENTS_FILTER:
			if (action) {
				return removeFilterFromEngagementComments(state, action.filterType, action.args);
			}
			return state;
		case DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL:
			if (action) {
				return setEngagementCommentInputModalData(state, action.modalConfig, action.args);
			}
			return state;
		case CREATE_ENGAGEMENT_COMMENT:
			if (action.response && !action.error) {
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				let _state = {...commentsState};
				const newGroupId = action.response.engagementCommentGuid;
				const newOpenGroup = createGroupForComment(action.response, newGroupId);
				const open = commentsState.open
					? {
							...commentsState.open,
							byId: {...commentsState.open.byId, [newGroupId]: newOpenGroup},
							allIds: [...commentsState.open.allIds, newGroupId]
						}
					: Utility.normalize(newOpenGroup, commentsState.open, 'id');

				if (action?.response?.entityUid) {
					const entityUid = action.response.entityUid;
					let entityUidsComments = [];
					if (!commentsState[entityUid]) {
						entityUidsComments = [action.response];
					} else {
						entityUidsComments = [...commentsState[entityUid], action.response];
					}
					_state = {
						...commentsState,
						open: open,
						[entityUid]: entityUidsComments
					};
				} else {
					_state = {
						...state,
						open: open
					};
				}
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, _state, action?.response?.entityUid);
				return _state;
			}
			return state;
		case CREATE_ENGAGEMENT_COMMENT_REPLY:
			if (action.response && !action.error) {
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				const group = getCommentGroup(commentsState, action.response.parentEngagementCommentGuid);
				const status = EngagementCommentStatusIds[group.byId[group.allIds[0]].engagementCommentStatusId];

				const stateResults = {
					...commentsState,
					[status]: {
						...commentsState[status],
						byId: {
							...commentsState[status].byId,
							[group.id]: {
								...commentsState[status].byId[group.id],
								byId: {
									...commentsState[status].byId[group.id].byId,
									[action.response.engagementCommentGuid]: action.response,
									[action.response.parentEngagementCommentGuid]: {
										...commentsState[status].byId[group.id].byId[action.response.parentEngagementCommentGuid],
										modifyDate: action.response.createDate
									}
								},
								allIds: [...commentsState[status].byId[group.id].allIds, action.response.engagementCommentGuid]
							}
						}
					}
				};
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, stateResults);
				return stateResults;
			}
			return state;
		case UPDATE_ENGAGEMENT_COMMENT:
			if (action.response && !action.error) {
				const commentGuid = action.response.parentEngagementCommentGuid ? action.response.parentEngagementCommentGuid : action.response.engagementCommentGuid;
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);

				const group = getCommentGroup(commentsState, commentGuid);

				const engagementCommentStatusId = action.response.parentEngagementCommentGuid
					? group.byId[group.allIds[0]].engagementCommentStatusId
					: action.response.engagementCommentStatusId;

				const status = EngagementCommentStatusIds[engagementCommentStatusId];

				const stateResults = {
					...commentsState,
					[status]: {
						...commentsState[status],
						byId: {
							...commentsState[status].byId,
							[group.id]: {
								...commentsState[status].byId[group.id],
								byId: {
									...commentsState[status].byId[group.id].byId,
									[action.response.engagementCommentGuid]: action.response
								}
							}
						}
					}
				};
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, stateResults);
				return stateResults;
			}
			return state;
		case UPDATE_ENGAGEMENT_COMMENT_STATUS:
			if (action.response && !action.error) {
				const commentGuid = action.response.parentEngagementCommentGuid ? action.response.parentEngagementCommentGuid : action.response.engagementCommentGuid;
				const newStatus = EngagementCommentStatusIds[action.response.engagementCommentStatusId];
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				let group = getCommentGroup(commentsState, commentGuid);

				group = {
					...group,
					byId: {
						...group.byId,
						[action.response.engagementCommentGuid]: action.response
					}
				};

				const partialState = removeGroupFromPreviousStatusSection(commentsState, group);

				const section = partialState[newStatus]
					? {
							...partialState[newStatus],
							byId: {...partialState[newStatus].byId, [group.id]: group},
							allIds: [...partialState[newStatus].allIds, group.id]
						}
					: Utility.normalize(group, partialState[newStatus], 'id');

				const entityUid = action.response.entityUid;
				let entityUidsComments = [];
				if (commentsState[entityUid]) {
					entityUidsComments = [...commentsState[entityUid]];
					const found = entityUidsComments.findIndex((c) => c.engagementCommentGuid === action.response.engagementCommentGuid);
					if (found >= 0) {
						const update = {...entityUidsComments[found]};
						update.engagementCommentStatusId = action.response.engagementCommentStatusId;
						entityUidsComments[found] = update;
					}
				}
				const stateResults = {
					...partialState,
					[entityUid]: entityUidsComments,
					[newStatus]: section
				};
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, stateResults, entityUid);
				return stateResults;
			}
			return state;
		case DELETE_ENGAGEMENT_COMMENT_PARENT:
			if (!action.error) {
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				const group = getCommentGroup(commentsState, action.parentEngagementCommentGuid);
				const entityUid = action.entityUid;
				let entityUidsComments = [];
				if (commentsState[entityUid]) {
					entityUidsComments = [...commentsState[entityUid]];
					const found = entityUidsComments.findIndex((c) => c.engagementCommentGuid === action.engagementCommentGuid);
					if (found > -1) {
						entityUidsComments.splice(found, 1);
					}
				}
				let _state = {...commentsState};
				_state = {
					...commentsState,
					[entityUid]: entityUidsComments
				};
				_state = removeGroupFromPreviousStatusSection(_state, group);
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, _state, entityUid);
				return _state;
			}
			break;
		case DELETE_ENGAGEMENT_COMMENT_CHILD:
			if (!action.error) {
				const commentsState = getStateForComments(state, action.args?.commentsStateKey);
				const group = getCommentGroup(commentsState, action.parentEngagementCommentGuid);

				const stateResults = removeReplyFromGroup(commentsState, group, action.engagementCommentGuid);
				mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, stateResults);
				return stateResults;
			}
			break;
		case UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS:
			if (action.bodyIds && !action.error) {
				const _state = _.cloneDeep(state);
				action.bodyIds.map((bodyId) => {
					if (_state[bodyId]) {
						const comments = _state[bodyId];
						if (comments) {
							comments.map((c) => {
								c.engagementCommentStatusId = EngagementCommentStatus.closed;
							});
						}
						mergeCommentGenericStateFromReduxState(null, _state, bodyId?.toString());
					}
				});
				return _state;
			}
			return state;
		case ADD_TO_ENGAGEMENT_COMMENT_SLICE:
			if (action.comment) {
				return applyResponse(state, action);
			}
			return state;
		case TOGGLE_INLINE_COMMENTS_EDITOR:
			console.log('REDUCER TOGGLE_INLINE_COMMENTS_EDITOR');
			if (action) {
				return setToggleInlineCommentEditor(state, action);
			}
			return state;
		default:
			return state;
	}
}

function applyResponse(state, action) {
	let _state = {...state};
	let response;
	switch (action.type) {
		case ADD_TO_ENGAGEMENT_COMMENT_SLICE:
			if (action.comment) {
				response = action.comment;
				if (response.length > 0) {
					_state = {
						..._state,
						[response[0].entityUid || response[0].id]: response
					};
				}
			}
			return _state;
		case GET_ALL_ENGAGEMENT_COMMENTS:
			if (action.response) {
				response = action.response;
				_state = {
					..._state,
					[EngagementCommentStatusIds[EngagementCommentStatus.open]]: {byId: {}, allIds: []},
					[EngagementCommentStatusIds[EngagementCommentStatus.cleared]]: {byId: {}, allIds: []},
					[EngagementCommentStatusIds[EngagementCommentStatus.closed]]: {byId: {}, allIds: []}
				};

				let commentStatuses;

				const allStatus = [
					EngagementCommentStatusIds[EngagementCommentStatus.open],
					EngagementCommentStatusIds[EngagementCommentStatus.cleared],
					EngagementCommentStatusIds[EngagementCommentStatus.closed]
				];

				for (let i = 0; i < allStatus.length; i++) {
					let section;
					const _status = allStatus[i];
					const _comments =
						response?.filter((comment) => {
							return EngagementCommentStatusIds[comment.engagementCommentStatusId] === _status;
						}) || [];

					for (let j = 0; j < _comments.length; j++) {
						const engagementComment = _comments[j];

						populateDefaultValues(engagementComment);

						const group = createGroupForComment(engagementComment);

						section = Utility.normalize(group, section);
						commentStatuses = Utility.normalize(
							{
								engagementCommentGuid: engagementComment.engagementCommentGuid,
								statusLabel: EngagementCommentStatusIds[engagementComment.engagementCommentStatusId],
								statusId: engagementComment.engagementCommentStatusId
							},
							commentStatuses,
							'engagementCommentGuid'
						);
					}

					_state = {
						..._state,
						[_status]: section || _state[_status],
						commentStatuses: commentStatuses
					};
				}
				if (response.length > 0) {
					_state = {
						..._state,
						[response[0].entityUid || response[0].id]: response
					};
				}
			}
			mergeCommentGenericStateFromReduxState(action.args?.commentsStateKey, _state, response.length ? response[0].entityUid || response[0].id : null);
			return _state;
	}
	return _state;
}

//Here we handle values needed to be set up which were not populated with a post deployment script.
function populateDefaultValues(comment) {
	if (!comment.dueDate) {
		comment.dueDate = new Date();
	}
}

function setEngagementCommentInputModalData(state, modalConfig, args = {}) {
	const commentsState = getStateForComments(state, args?.commentsStateKey);
	const _state = {
		...commentsState,
		...state,
		modalConfig: modalConfig
	};

	mergeCommentGenericStateFromReduxState(args?.commentsStateKey, _state);
	return _state;
}

function setToggleInlineCommentEditor(state, action) {
	console.log('REDUCER TOGGLE_INLINE_COMMENTS_EDITOR STATE CHANGE');
	const _state = {
		...state,
		isInlineEditorOpen: action.toggle
	};

	return _state;
}

function clearEngagementComments(entityUid, state, args = {}) {
	const _state = {
		...state,
		open: undefined,
		cleared: undefined,
		closed: undefined,
		config: {},
		filters: undefined,
		selectedCommentGuid: undefined
	};

	mergeCommentGenericStateFromReduxState(args?.commentsStateKey, _state);
	return _state;
}

function addFilterToEngagementComments(state, filter, args = {}) {
	let _state;
	const commentsState = getStateForComments(state, args?.commentsStateKey);
	if (commentsState.filters && commentsState.filters.allIds.length > 0) {
		if (commentsState.filters.allIds.indexOf(filter.filterType) > -1) {
			_state = {
				...commentsState,
				filters: {
					...commentsState.filters,
					byId: {
						...commentsState.filters.byId,
						[filter.filterType]: filter
					}
				}
			};
		} else {
			_state = {
				...commentsState,
				filters: {
					...commentsState.filters,
					byId: {...commentsState.filters.byId, [filter.filterType]: filter},
					allIds: [...commentsState.filters.allIds, filter.filterType]
				}
			};
		}
	} else {
		_state = {
			...commentsState,
			filters: Utility.normalize(filter, commentsState.filters, 'filterType')
		};
	}
	mergeCommentGenericStateFromReduxState(args?.commentsStateKey, _state);
	return _state;
}

function removeFilterFromEngagementComments(state, filterType, args = {}) {
	let commentsState = getStateForComments(state, args?.commentsStateKey);
	if (commentsState.filters && commentsState.filters.allIds.indexOf(filterType) > -1) {
		const filters = [];
		for (let i = 0; i < commentsState.filters.allIds.length; i++) {
			const _filterType = commentsState.filters.allIds[i];

			if (_filterType !== filterType) {
				filters.push(commentsState.filters.byId[_filterType]);
			}
		}
		//We keep the rest of the filters.
		if (filters.length > 0) {
			commentsState = {
				...commentsState,
				filters: Utility.normalize(filters, undefined, 'filterType')
			};
		} else {
			//There is no filter to apply to the chart.
			commentsState = {
				...commentsState,
				filters: undefined
			};
		}
	}

	mergeCommentGenericStateFromReduxState(args?.commentsStateKey, {...commentsState});
	return commentsState;
}

function setSelectedEngagementCommentGuid(state, guid, args = {}) {
	const commentsState = getStateForComments(state, args?.commentsStateKey);
	const _state = {
		...commentsState,
		selectedCommentGuid: guid
	};
	mergeCommentGenericStateFromReduxState(args?.commentsStateKey, _state);
	return _state;
}

//Will create a new group { id: number, byId: {}, allIds: []} for a new parent comment
function createGroupForComment(engagementComment) {
	let group;

	group = Utility.normalize(engagementComment, group, 'engagementCommentGuid');

	if (engagementComment.replies && engagementComment.replies.length > 0) {
		for (let j = 0; j < engagementComment.replies.length; j++) {
			const childEngagementComment = engagementComment.replies[j];

			group = Utility.normalize(childEngagementComment, group, 'engagementCommentGuid');
		}
	}

	group['id'] = engagementComment.engagementCommentGuid;

	return group;
}

//This will give you the Group { id: number, byId: {}, allIds: []} which holds the comment.
function getCommentGroup(engagementComments, commentGuid) {
	const allStatus = [EngagementCommentStatusIds[1], EngagementCommentStatusIds[2], EngagementCommentStatusIds[3]];
	let byId = {};
	let allIds = [];
	let group;

	for (let j = 0; j < allStatus.length; j++) {
		if (engagementComments[allStatus[j]]) {
			byId = engagementComments[allStatus[j]].byId;
			allIds = engagementComments[allStatus[j]].allIds;

			for (let i = 0; i < allIds.length; i++) {
				group = byId[allIds[i]];

				const index = group.allIds.indexOf(commentGuid);

				if (index > -1) {
					return group;
				}
			}
		}
	}

	return undefined;
}

function removeReplyFromGroup(state, group, engagementCommentGuid) {
	let alteredGroup;
	const section = EngagementCommentStatusIds[group.byId[group.allIds[0]].engagementCommentStatusId];

	for (let i = 0; i < group.allIds.length; i++) {
		const guid = group.allIds[i];
		const engagementComment = group.byId[guid];

		if (engagementComment.engagementCommentGuid !== engagementCommentGuid) {
			alteredGroup = Utility.normalize(engagementComment, alteredGroup, 'engagementCommentGuid');
		}
	}

	alteredGroup['id'] = group.id;

	return {
		...state,
		[section]: {
			...state[section],
			byId: {
				...state[section].byId,
				[group.id]: alteredGroup
			}
		}
	};
}

//Will remove the group from its previous status section.
function removeGroupFromPreviousStatusSection(engagementComments, group) {
	let previousStatus = '';
	const allStatus = [EngagementCommentStatusIds[1], EngagementCommentStatusIds[2], EngagementCommentStatusIds[3]];
	const comments = [];

	for (let i = 0; i < allStatus.length; i++) {
		previousStatus = allStatus[i];

		if (engagementComments[previousStatus] && engagementComments[previousStatus].allIds.indexOf(group.id) > -1) {
			break;
		}
	}

	for (let i = 0; i < engagementComments[previousStatus].allIds.length; i++) {
		const groupId = engagementComments[previousStatus].allIds[i];

		if (groupId !== group.id) {
			comments.push(engagementComments[previousStatus].byId[groupId]);
		}
	}

	return {
		...engagementComments,
		[previousStatus]: Utility.normalize(comments, undefined, 'id')
	};
}
